class CardCarousel extends HTMLElement {
  constructor() {
    super();
    this.carousel = null;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.carousel = new Splide(this.querySelector('.splide'),
      {
        arrows: false,
        perPage: 8,
        gap: 'var(--spacing-md)',
        drag: 'free',
        breakpoints: {
          2000: {
            perPage: 6,
          },
          768: {
            perPage: 1.6,
            gap: 'var(--spacing-xs)',
            focus: 0,
          }
        },
      },
    );

    this.carousel.mount();
  }
}

customElements.define('card-carousel', CardCarousel);
